<script lang="ts" setup>
import { ConfirmDialogProvider, PageFooter, PageLayout, Toaster } from '@dailycare-au/ui'
import { useHead } from '@unhead/vue'
import { useRoute } from 'vue-router'

const route = useRoute()
useHead({ title: () => route.meta.title as string | null })
</script>

<template>
  <PageLayout>
    <RouterView v-slot="{ Component }">
      <component :is="Component" />
    </RouterView>

    <PageFooter />
  </PageLayout>

  <Toaster />
  <ConfirmDialogProvider />
</template>
